import objectKeyFilter from "common/utils/objectKeyFilter";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_96: DocMigration = {
  maxSchemaVersion: "0.0.96",
  description: "remove settings overrides",
  apply(json: any) {
    if (json.hidden) {
      json.hidden = objectKeyFilter(json.hidden, (id) => json.hidden[id].type !== "SETTINGS_OVERRIDE");
    }

    if (json.locked) {
      json.locked = objectKeyFilter(json.locked, (id) => json.locked[id].type !== "SETTINGS_OVERRIDE");
    }

    return json;
  },
};

export default migration_0_0_96;
